import styled from "styled-components";
import { siteDarkBlue } from "../../providers/Theme";

export const StyledFooter = styled.footer`
  background: ${siteDarkBlue};
  padding: 3rem 1.5rem 2rem;
  color: white;
`;

export const Inner = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem 3rem;

  ${({ theme }) => theme.sm`
    grid-template-columns: 1fr 1fr;
  `}

  ${({ theme }) => theme.lg`
    grid-template-columns: 1.4fr 1fr 1fr 1.5fr;
  `}
`;

export const LogoImg = styled.img`
  height: 72px;
  width: auto;
  margin-bottom: 1.1rem;
  display: block;
`;

export const Tagline = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  line-height: 1.65;
  margin-bottom: 0.75rem;
`;

export const EINText = styled.p`
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.85rem;
  margin-bottom: 1.1rem;
`;

export const SocialRow = styled.div`
  display: flex;
  gap: 0.9rem;
`;

export const SocialLink = styled.a`
  color: white;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.65;
    color: white;
  }
`;

export const ColHeading = styled.h4`
  color: white;
  font-weight: 800;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 1.1rem;
`;

export const NavLinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const NavLinkItem = styled.li`
  margin-bottom: 0.6rem;

  button {
    background: none;
    border: none;
    padding: 0;
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.9rem;
    text-align: left;
    cursor: pointer;

    &:hover {
      color: white;
      text-decoration: underline;
    }

    &:disabled {
      opacity: 0.45;
      cursor: default;
    }
  }
`;

export const StayText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

export const EmailForm = styled.form`
  position: relative;
  margin-bottom: 1.75rem;
`;

export const EmailInput = styled.input.attrs({
  type: "email",
  placeholder: "Email Address",
  name: "EMAIL",
  required: true
})`
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 6px;
  color: #333;
  padding: 0.6rem 1rem;
  font-size: 0.875rem;
  width: 100%;
  margin-bottom: 0.5rem;

  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: 2px solid rgba(255, 255, 255, 0.5);
  }
`;

export const SubscribeButton = styled.button.attrs({ type: "submit" })`
  width: 100%;
  background: white;
  color: ${siteDarkBlue};
  font-weight: 700;
  font-size: 0.875rem;
  border: none;
  border-radius: 6px;
  padding: 0.6rem 1rem;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.85;
  }
`;

export const ContactLine = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  margin-bottom: 0.3rem;
`;
